import { MaskText, SectionLabel, Reveal, Counter } from "./primitives";

const STATS = [
  { value: 12, suffix: "+", label: "Years crafting brands" },
  { value: 240, suffix: "+", label: "Projects delivered" },
  { value: 60, suffix: "+", label: "Clients & partners" },
  { value: 3, suffix: "", label: "Studios · Iraq, UAE & Jordan" },
];

export default function About() {
  return (
    <section
      id="studio"
      data-testid="studio-section"
      className="relative bg-dm-light py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <SectionLabel tone="maroon" className="text-dm-maroon">The studio</SectionLabel>
            <MaskText
              lines={["Three cities.", "One relentless", "creative engine."]}
              className="mt-5 font-display font-extrabold text-dm-dark tracking-tighter leading-[0.94] text-4xl sm:text-5xl md:text-6xl"
            />
            <Reveal delay={0.15}>
              <p className="mt-7 max-w-lg text-dm-dark/60 leading-relaxed text-base md:text-lg">
                Doctor Media is a creative marketing and design studio rooted in
                Baghdad, Dubai and Amman. We blend regional insight with world-class
                craft — a tight, senior team that treats every brand like a
                patient worth diagnosing before we prescribe.
              </p>
            </Reveal>
            <Reveal delay={0.25}>
              <p className="mt-4 max-w-lg text-dm-dark/60 leading-relaxed">
                No hand-offs, no filler. Strategy, design and production sit in
                one room, so the work stays sharp from brief to launch.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-6">
            <Reveal delay={0.1}>
              <div className="relative overflow-hidden clip-br h-[420px] md:h-[520px]">
                <img
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=1400&auto=format&fit=crop"
                  alt="Doctor Media team"
                  className="h-full w-full object-cover"
                />
                <div
                  className="absolute inset-0"
                  style={{ background: "linear-gradient(160deg, rgba(39,90,113,0.35), rgba(140,39,45,0.25))" }}
                />
              </div>
            </Reveal>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-6 border-t pt-14"
          style={{ borderColor: "rgba(10,10,10,0.12)" }}>
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div data-testid={`stat-${i}`}>
                <div className="font-display font-extrabold tracking-tighter text-5xl md:text-6xl"
                  style={{ color: i % 2 === 0 ? "var(--dm-teal)" : "var(--dm-maroon)" }}>
                  <Counter value={s.value} suffix={s.suffix} />
                </div>
                <p className="mt-2 text-dm-dark/55 text-sm max-w-[160px]">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
